import type { FC, ReactElement } from 'react';

import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useCoreDispatch } from '../../../store/CoreStore';
import { popupActions } from '../../../store/slices/popup/slice';
import { settingsActions } from '../../../store/slices/settings/slice';
import { Button, ButtonVariant } from '../../controls/button/Button';
import { PopupType } from '../../popup/types';

import { BlockingModalContent } from './BlockingModalContent';

export const VideoIsDisabledConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();

  const action = [
    <Button
      key="CANCEL"
      tk="CANCEL"
      variant={ButtonVariant.MAIN}
      onClick={() => {
        dispatch(popupActions.dismissPopup(PopupType.VideoIsDisabled));
      }}
    />,
    <Button
      key="ENABLE"
      tk="ENABLE"
      variant={ButtonVariant.ACCENT}
      onClick={() => {
        dispatch(popupActions.dismissPopup(PopupType.VideoIsDisabled));
        dispatch(settingsActions.setStreamEnabled(true));
      }}
    />,
  ];

  return (
    <BlockingModalContent actions={action}>
      <L10nText tk="NO_VIDEO_BODY" />
    </BlockingModalContent>
  );
};
